import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import {
  Autocomplete,
  Checkbox,
  FormControl,
  Grid,
  TextField,
} from '@mui/material';

import { GridSizeType, gridSize } from '@/shared';

export type CustomAutocompleteMultipleArrStringNoFormProps = {
  options: string[];
  defaultValue: string[];

  loadingText?: string;
  isLoadingData: boolean;

  // form
  label: string;
  name?: string;
  disabled?: boolean;
  onChangeValue?: (value: string[] | string) => void;
  helperText?: React.ReactNode;
  required?: boolean;
  textFieldKey?: string;
  size?: GridSizeType;
  enableStringify?: boolean;
  value?: string[];

};

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function CustomAutocompleteMultipleArrStringNoForm({
  options,
  isLoadingData,
  loadingText = 'Cargando...',

  // form
  label,
  defaultValue,
  helperText,
  required = true,
  disabled = false,
  onChangeValue,

  size = gridSize,
  enableStringify = true,
  value
}: Readonly<CustomAutocompleteMultipleArrStringNoFormProps>) {


  return (
    <Grid item {...size}>
      <FormControl fullWidth>
        <Autocomplete
          popupIcon={null}
          multiple
          id="checkboxes-tags-demo"
          limitTags={2}
          value={value}
          defaultValue={defaultValue}
          options={options}
          loading={isLoadingData}
          loadingText={loadingText}
          disableCloseOnSelect
          getOptionLabel={(option: any) => option}
          renderOption={(props, option, { selected }) => (
            <li {...props}>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {option}
            </li>
          )}

          onChange={(_event: any, data: any) => {

            if (!enableStringify)
              return onChangeValue && onChangeValue(data);

            const selectedValue: string = JSON.stringify(data || '[]');
            onChangeValue && onChangeValue(selectedValue);
          }}
          disabled={disabled}
          renderInput={params => (
            <TextField
              {...params}
              label={label}
              variant="outlined"
              helperText={helperText}
              required={required}
              disabled={disabled}
            />
          )}
        />
      </FormControl>
    </Grid>
  );
}
